import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Axios from "axios";

import { url } from "../../../../../config/config";
import SignUpForm from "../SignUpForm/SignUpForm";
import { useStyles } from "./CustomerSignUp.css";

class CustomerSignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
      error: {
        firstNameError: "",
        lastNameError: "",
        emailError: "",
        passwordError: "",
        confirmPasswordError: "",
      },
      successMessage: "",
      success: "",
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  checkError = (EmailError) => {
    let firstNameError = "";
    let lastNameError = "";
    let emailError = EmailError;
    let passwordError = "";
    let confirmPasswordError = "";

    if (this.state.data.firstName.length < 3) {
      firstNameError = "First Name must be minimum of 3 characters";
    }
    if (this.state.data.lastName.length < 3) {
      lastNameError = "Last Name must be minimum of 3 characters";
    }
    if (this.state.data.password.length < 8) {
      passwordError = "Password must be minimum of 8 characters";
    }
    if (this.state.data.confirmPassword !== this.state.data.password) {
      confirmPasswordError = "Password must be matched";
    }
    if (
      firstNameError ||
      lastNameError ||
      emailError ||
      passwordError ||
      confirmPasswordError
    ) {
      this.setState({
        error: {
          firstNameError,
          lastNameError,
          emailError,
          passwordError,
          confirmPasswordError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          firstNameError: "",
          lastNameError: "",
          emailError: "",
          passwordError: "",
          confirmPasswordError: "",
        },
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.setState({ loading: true });
      const response = await Axios.post(`${url}/api/users`, this.state.data);
      if (response.data.emailError) {
        this.checkError(response.data.emailError);
        this.setState({ loading: false });
      } else {
        if (response.data.success && errorStatus === false) {
          this.setState({ success: response.data.success });
          this.props.history.push("/login/Customer");
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <SignUpForm
            loading={this.state.loading}
            label="Customer"
            data={this.state.data}
            error={this.state.error}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
          <br />
          <div style={{ display: "flex", justifyContent: "center" }}>
            Already have account?&nbsp; <Link to="/login/Customer">Login</Link>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            Go to&nbsp; <Link to="/">Home</Link>
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(CustomerSignUp));
